function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.174.483L.223 5.448A.536.536 0 0 0 0 5.88v9.221c0 .279.261.532.549.532H14.45c.288 0 .549-.253.549-.532v-9.22a.534.534 0 0 0-.223-.433L7.826.483c-.236-.14-.435-.126-.652 0z" fill="#4F5EA3" /></svg>;
});